export default __webpack_public_path__ + "static/media/dotsSelected.5d119edd.svg";